import gql from 'graphql-tag';

export const GET_DRC_PAGINATED_NON_PROPOSED = gql`
  query (
    $filter: ApplicationViewFilter
    $sort: ApplicationViewSort
    $paginator: PaginatorOptions
  ) {
    applicationViewsPaginated(
      filter: $filter
      sort: $sort
      paginator: $paginator
    ) {
      data {
        id
        applicationNo
        applicant {
          name {
            givenName
            surname
          }
        }
        programmeChoice {
          department
          programmeType
          programme
          researchArea
          proposedChiefSupervisor
          proposedChiefSupervisorBackup
          rejectedByFirstChoice
          studyMode
          entryYear
        }
        hkpfsInformation {
          HKPFSReferenceNumber
          validHKPFSApplication
        }
        nomination {
          fundings {
            source
            status
          }
          submission {
            lastSubmissionTime
          }
        }
        status

        updatedAt
      }
      paginator {
        total_pages
        count
      }
    }
  }
`;
